import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/streams";

export default function CategoryGrid() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          onClick={() => navigate(`/category/${cat.id}`)}
          className="group flex flex-col items-center gap-2 rounded-lg border border-background-200/70 bg-background-100 px-3 py-5 transition-colors hover:border-primary-500/60"
        >
          <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500/12 text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${cat.icon} text-xl`}></i>
          </span>
          <span className="text-sm text-foreground-800">{cat.name}</span>
          <span className="text-[11px] text-foreground-400">{cat.tagline}</span>
        </button>
      ))}
    </div>
  );
}